"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurancePaymentReport = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
const insurance_payment_header_1 = require("./components/insurance-payment-header");
const number_formatter_1 = require("../claim-analytics/number-formatter");
require("./insurance-payment-report.less");
let InsurancePaymentReport = class InsurancePaymentReport extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Insurance_Payment_Report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    else {
                        return a > b ? 1 : a < b ? -1 : 0;
                    }
                }
            },
            columnDefs: [
                {
                    headerName: "Rx #",
                    field: "Rx #",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Date Dispensed",
                    field: "Date Dispensed",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                },
                {
                    headerName: "NDC #",
                    field: "NDC #",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Med Name",
                    field: "Med Name",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Quantity Dispensed",
                    field: "Quantity Dispensed",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Insurance Amount",
                    field: "Insurance Amount",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Patient Bin",
                    field: "Patient Bin",
                    filter: "agTextColumnFilter"
                },
                {
                    headerName: "Patient PCN",
                    field: "Patient PCN",
                    filter: "agTextColumnFilter"
                }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        // Problem with auto loading so much data, restricting auto load to 1 week
        // Then user can still enter whatever time frame they want.
        const date = new Date().toDateString();
        const endDate = moment(date).format("YYYY-MM-DD");
        const startDate = moment(date)
            .subtract(7, "days")
            .format("YYYY-MM-DD");
        await store_1.reportsStore.loadInsurancePaymentReport("", startDate, endDate);
    }
    componentWillUnmount() {
        store_1.reportsStore.insurancePaymentReportData = null;
    }
    render() {
        const storeData = store_1.reportsStore.insurancePaymentReportData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(insurance_payment_header_1.InsuranceAnalyticsHeader, { title: "Insurance Analytics", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(insurance_payment_header_1.InsuranceAnalyticsHeader, { title: "Insurance Analytics", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(insurance_payment_header_1.InsuranceAnalyticsHeader, { title: "Insurance Analytics", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
InsurancePaymentReport = __decorate([
    mobx_react_1.observer
], InsurancePaymentReport);
exports.InsurancePaymentReport = InsurancePaymentReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/insurance-payment-report/insurance-payment-report.tsx
// module id = 3908
// module chunks = 0